import React, { useState } from 'react';
import { DoctoralPublication } from '../types';
import { OFFICIAL } from '../doctoralTemplate';
import { Card, Hero, SourceCard } from './dp120Parts';

interface DoctoralPublicationsViewProps {
  publications: DoctoralPublication[];
  onOpenAddPubModal: () => void;
}

const TABS: [string, string][] = [
  ['all', 'Все'],
  ['scopus', 'Scopus'],
  ['wos', 'Web of Science'],
  ['committee', 'Перечень Комитета'],
  ['conf', 'Конференции'],
  ['other', 'Другие результаты'],
];

function matches(item: DoctoralPublication, tab: string) {
  const index = (item.indexing || '').toUpperCase();
  if (tab === 'all') return true;
  if (tab === 'scopus') return index.includes('SCOPUS');
  if (tab === 'wos') return index.includes('WOS') || index.includes('WEB OF SCIENCE');
  if (tab === 'committee') return index.includes('COX') || index.includes('КОКС') || index.includes('COMMITTEE');
  if (tab === 'conf') return index.includes('CONF');
  return !['SCOPUS', 'WOS', 'COXNVO', 'CONFERENCE'].some((mark) => index.includes(mark));
}

export const DoctoralPublicationsView: React.FC<DoctoralPublicationsViewProps> = ({
  publications,
  onOpenAddPubModal,
}) => {
  const [tab, setTab] = useState('all');
  const visible = publications.filter((item) => matches(item, tab));

  return (
    <>
      <Hero
        kicker="PUBLICATION RECORD"
        title="Публикации и академическая активность"
        text="Единый реестр публикаций с фильтрами Scopus, Web of Science, Перечень Комитета, конференции и другие результаты."
        color="#4ce2bf"
        actions={
          <button type="button" className="dp120-btn mint" onClick={onOpenAddPubModal}>
            + Добавить публикацию
          </button>
        }
      />
      <div className="dp120-subtabs">
        {TABS.map(([key, label]) => (
          <button key={key} type="button" className={tab === key ? 'active' : ''} onClick={() => setTab(key)}>
            {label}
          </button>
        ))}
      </div>
      <div className="dp120-grid">
        <Card
          title={TABS.find((item) => item[0] === tab)?.[1] || 'Публикации'}
          sub="Одна публикация может иметь несколько индексационных признаков."
          span="span12"
        >
          <div className="dp120-list">
            {visible.length === 0 && <div className="dp120-empty">В этом фильтре публикаций пока нет.</div>}
            {visible.map((item) => (
              <div key={item.id || item.title} className="dp120-row">
                <span>
                  <strong>{item.title}</strong>
                  <small>
                    {item.journal}
                    {item.year ? ` · ${item.year}` : ''}
                    {item.doi ? ` · ${item.doi}` : ''}
                    {item.quartile_percentile ? ` · ${item.quartile_percentile}` : ''}
                  </small>
                </span>
                <span className="dp120-badge good">{item.indexing}</span>
              </div>
            ))}
          </div>
        </Card>
        <Card title="Готовность публикаций к защите" span="span12">
          <SourceCard
            title="Правила присуждения степеней"
            text="Система хранит применяемую редакцию требований, дату проверки и ссылку на официальный источник. Перед защитой нужна актуальная проверка."
            links={[
              ['Правила присуждения степеней', OFFICIAL.degree],
              ['Нормативные документы ENU', OFFICIAL.regulations],
              ['Диссертационный совет ENU', OFFICIAL.defense],
            ]}
          />
        </Card>
      </div>
    </>
  );
};
